import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';

const QuiSuisJe = (props) => {
  return (
    <div>
          <Header />

    <div id="quisuisje">

      <div className="container">
        <div>
          <div className="col-xs-12 col-md-6">
            {" "}
            <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="quisuisje-text">
              <h2>Qui suis-je ?</h2>
              <br></br>
              <br></br> 
              <p>Swaly forme est plus qu’un nom, c'est mon histoire. 
                <br></br>
                <br></br>Ayant grandi dans des foyers, le sport a toujours été mon échappatoire pour ne pas sombrer dans la détresse, car les valeurs qu’il inculque sont celles de la vie quotidienne.</p>
<br></br>
<p>Etant athlète, j’ai appris à me concentrer sur mes objectifs et en tirer le meilleur, quelque soit la défaite ou la victoire.
  <br></br>
  <br></br>
J'ai fait du bénévolat, au sein de plusieurs associations sportives, en tant que coach, afin d’accroître mon envie de transmettre ma passion.</p>
<br></br>
<ul>
  <p><li>A 40 ans, je décide de sortir des starting-blocks et en faire mon métier, en créant la méthode Swaly Forme, afin de partager cette sensation de bien-être après une séance de sport tel que la course, la marche, le renforcement musculaire, la boxe ...</li></p>
  <br></br>
  <p><li>D’où ma devise avoir foi en soi, car prendre soin de soi, passe par le corps, l’assiette et l’environnement.</li></p>
<br></br>
<p><li>	ON N’A RIEN SANS RIEN.</li></p>
</ul>
<br></br>
<br></br>
<h4>Diplômes et formations professionnelles :</h4>
<br></br>
<ul>
  <p><li>BPJEPS APT (Brevet Professionnel de la Jeunesse, de l'Education Populaire et du Sport, option Activités Pour Tous</li></p>
  <p><li>Instructeur Pilates (niveau 1 et 2)</li></p>
  <p><li>Travail avec petit matériel</li></p>
</ul>

            </div>
          </div>
        </div>

      </div>
      </div>
      <Footer />

    </div>
  );
};
export default QuiSuisJe